import { useRouter } from "next/router";

export default function PaymentDefaults() {
  const router = useRouter();
  router.replace("/payment-defaults/pay-in");

  return <></>;
}
